import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { useRepositories } from '../../../infrastructure/http/RepositoryProvider';
import { savePendingShareToken } from '../../../infrastructure/browser/pendingShare';
import type { AcceptedInvite } from '../../../domain/DeviceShare';

export function useJoinDevice() {
  const location = useLocation();
  const history = useHistory();
  const { isAuthenticated } = useAuth();
  const { deviceShares } = useRepositories();
  const token = new URLSearchParams(location.search).get('token') ?? '';

  const [status, setStatus] = useState<'accepting' | 'done' | 'error'>(token ? 'accepting' : 'error');
  const [error, setError] = useState<string | null>(token ? null : 'El código no es válido.');
  const [result, setResult] = useState<AcceptedInvite | null>(null);

  useEffect(() => {
    if (!token) return;
    if (!isAuthenticated) {
      savePendingShareToken(token);
      history.replace('/login');
      return;
    }
    deviceShares
      .acceptInvite(token)
      .then((res) => {
        setResult(res);
        setStatus('done');
      })
      .catch((err) => {
        setError(err instanceof Error ? err.message : 'No se pudo aceptar la invitación.');
        setStatus('error');
      });
  }, [isAuthenticated, token, history, deviceShares]);

  return { status, error, result, history };
}
